import { Loader2 } from 'lucide-react';

/*
 * Full-screen pending state for the funnel-gated pages (/pricing, /onboarding,
 * /billing/update-card). Deliberately bare rather than wrapped in BillingLayout: that shell
 * takes priceLabel/footerValue/footerTone props, which are exactly the status-dependent
 * values we don't have yet while the status call is in flight — on /billing/update-card it
 * would render "Status: Past Due" in the plan panel before that's been verified.
 *
 * #080c09 is the shared base colour of all three shells (BillingLayout's radial gradient and
 * every OnboardingLayout step background resolve to it), so this doesn't flash a different
 * background before the real page paints.
 */
const Loader = () => (
    <div className="cv2-dark min-h-dvh flex items-center justify-center" style={{ background: '#080c09' }}>
        <Loader2 className="w-6 h-6 text-claraview-secondary animate-spin" strokeWidth={2} />
    </div>
);

export default Loader;
